import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const PilotChannelTitleContainer = styled.div<React.CSSProperties>`
    align-items: center;
    display: flex;
    position: ${(props) => props.position || 'absolute'};
    bottom: ${242 * Screen.widthRatio}px;
    left: ${283 * Screen.widthRatio}px;
    width: auto;
}
`;

export default PilotChannelTitleContainer;
